export const SCREEN_LG = 1200;
export const SCREEN_LG_MIN = SCREEN_LG;

export const SCREEN_MD = 992;
export const SCREEN_MD_MIN = SCREEN_MD;
export const SCREEN_MD_MAX = SCREEN_LG_MIN - 1;

export const SCREEN_SM = 768;
export const SCREEN_SM_MIN = SCREEN_SM;
export const SCREEN_SM_MAX = SCREEN_MD_MIN - 1;

export const SCREEN_XS = 480;
export const SCREEN_XS_MIN = SCREEN_XS;
export const SCREEN_XS_MAX = SCREEN_SM_MIN - 1;
